import {ProductInterface} from "../../interfaces/product/ProductInterface";
import {Link} from "react-router-dom";

export default function BundleIncludes({product}: { product: ProductInterface }) {
    const parseItemText = (text: string) => {
        const categoryMatch = text.match(/\[#(\d+)\/([^#]+)#\]/);
        if (categoryMatch) {
            const rawPrefix = categoryMatch[2];
            const cleanText = text.replace(/\[#[^#]+#\]/, '').trim();
            return { type: 'prefix' as const, href: `/catalog/by-code/${rawPrefix}`, text: cleanText };
        }

        const codeMatch = text.match(/\[%(\d+)%\]/);
        if (codeMatch) {
            const code = codeMatch[1];
            const cleanText = text.replace(/\[%\d+%\]/, '').trim();
            return { type: 'product' as const, href: `/catalog/item-by-code/${code}`, text: cleanText };
        }

        return { type: 'plain' as const, href: null, text };
    }

    if (!product.additional_params?.specification_list_raw?.length) {
        return null;
    }

    return (
        <div className="flex-column flex-lg-row gap-4 justify-content-between prod-pane">
            <div className="d-flex flex-column prod-pane__left">
                <div className="d-flex flex-column prod-pane__right-body">
                    <p className="fw-bold text-uppercase">Комплектация</p>
                    <ul className="d-flex flex-column">
                        {product.additional_params.specification_list_raw.map((item, index) => {
                            const {href, text} = parseItemText(item);
                            return (
                                <li key={index}>
                                    {text.trim() && <span className="t-orange cicle">●</span>}
                                    {href ? (
                                        <Link to={href}
                                              className="t-orange text-decoration-underline">{text}</Link>
                                    ) : (
                                        <span>{text}</span>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </div>
    );
}
